export default __webpack_public_path__ + "static/media/lieferheld_l1.7c6244e4.png";